"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var datapoints_1 = require("./datapoints");
var moveMailListRowsHelper_1 = require("./helpers/moveMailListRowsHelper");
var actionTypes_1 = require("owa-mail-store/lib/actions/actionTypes");
var moveConversationService_1 = require("owa-mail-store/lib/services/moveConversationService");
var undoActions = require("owa-mail-undo");
var legacy_1 = require("satcheljs/lib/legacy");
var stitch_1 = require("satcheljs/lib/legacy/stitch");
var owa_mail_list_store_1 = require("owa-mail-list-store");
/**
 * The action worker which handles moving conversations.
 * @param rowKeys - the row keys of the rows that, need to be moved
 * @param destinationFolderId - the folder they need to go to
 * @param originalTableView - the table view the rows are moving from
 */
exports.default = legacy_1.action('moveConversations', datapoints_1.default.moveConversationDatapoint)(function moveConversations(rowKeys, destinationFolderId, originalTableView, actionSource) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            return [2 /*return*/, moveMailListRowsHelper_1.default(rowKeys, destinationFolderId, originalTableView, moveConversationsInternal, actionSource)];
        });
    });
});
/**
 * The move conversations internal method
 * @param rowKeys - the row keys of the rows that need to be moved
 * @param destinationFolderId - the folder they need to go to
 * @param originalTableView - the table view the rows are moving from
 */
function moveConversationsInternal(rowKeys, destinationFolderId, originalTableView, sourceFolderId) {
    // Task 658: Reload client state when move conversation fails on the server.
    var conversationActionContexts = rowKeys.map(function (rowKey) {
        return owa_mail_list_store_1.getApplyConversationActionContext(rowKey, originalTableView.id);
    });
    var conversationIdStrings = owa_mail_list_store_1.getRowIdsFromRowKeys(rowKeys, originalTableView.id);
    stitch_1.raiseAction(actionTypes_1.actionNames.DeleteConversationStoreUpdate)(conversationIdStrings, originalTableView);
    // Make service request
    return (moveConversationService_1.default(conversationActionContexts, destinationFolderId, sourceFolderId)
        .then(function (response) {
        if (response.ResponseClass == 'Success') {
            undoActions.addActionToUndoStack(function () {
                return moveConversationService_1.default(conversationActionContexts, sourceFolderId, destinationFolderId);
            });
        }
        else {
            // VSO 21472: Error handling for triage actions
        }
    })
        .catch());
}
//# sourceMappingURL=moveConversations.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/moveConversations.js
// module id = 5592
// module chunks = 62